import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import Landing from "./pages/Landing";
import ServiceDetail from "./pages/ServiceDetail";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services/:id" element={<ServiceDetail />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </ReactLenis>
    </HelmetProvider>
  );
}

export default App;
